<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <p [innerText]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">{{ data.cancelText || 'Cancelar' }}</button>
  <button mat-raised-button color="primary" (click)="onYesClick()">{{ data.confirmText || 'Confirmar' }}</button>
</mat-dialog-actions>
